{
  "checkBackSoonMessage": "Nous espérons que cette fonctionnalité sera bientôt opérationnelle. Revenez bientôt !",
  "contactUs": "Contactez-nous",
  "errorBoundaryTitle": "Quelque chose s'est mal passé",
  "featureInProgressMobileWithWebappUrl": "Nous travaillons actuellement au transfert de cette fonctionnalité de notre application Web vers les plateformes mobiles.\nEn attendant, vous pouvez utiliser cette fonctionnalité sur {{webappUrl}}",
  "loadErrorDismissButton": "Rejeter",
  "retryButton": "Réessayer",
  "loadErrorMessage": "Notre équipe a été informée et travaille à résoudre le problème.",
  "loadErrorSupportTicketLink": "Créer un ticket d'assistance",
  "loadErrorSupportTicketMessage": "Créez un ticket d'assistance pour suivre votre problème.",
  "loadErrorTitle": "Quelque chose s'est mal passé",
  "notFoundMessage": "Le contenu que vous avez demandé n'existe pas.",
  "notFoundTitle": "Non trouvé",
  "permissionDeniedHowToGetPermissionHint": "Pour accéder à cette fonctionnalité, contactez un administrateur de votre compte agricole.",
  "permissionDeniedMessage": "Vous n'avez pas l'autorisation d'effectuer cette action.",
  "permissionDeniedMissingPermissions": "Autorisations manquantes :",
  "permissionDeniedTitle": "Permission refusée",
  "reloadButton": "Recharger",
  "underConstruction": "En construction"
}
